import { useState, useLayoutEffect } from 'react';

export type Size = 'large' | 'medium' | 'small' | '';

function getSize(node: HTMLElement): Size {
    const rect = node?.getBoundingClientRect();
    if (!rect) return '';

    if (rect.width > 450) {
        return 'large';
    } else if (rect.width > 300) {
        return 'medium';
    } else {
        return 'small';
    }
}

function useSize(ref): Size {
    const [size, setSize] = useState<Size>('');

    useLayoutEffect(() => {
        if (ref?.current) {
            const measure = () =>
                window.requestAnimationFrame(() =>
                    setSize(getSize(ref.current)),
                );
            measure();

            window.addEventListener('resize', measure);

            return () => {
                window.removeEventListener('resize', measure);
            };
        }
        return () => {};
    }, [ref]);

    return size;
}

export default useSize;
